'use client';

import { IncidentDetailView } from './IncidentDetailView';
import { useIncidentDetailScreen } from '@/app/hooks/incident/useIncidentDetailScreen';

type IncidentDetailContainerProps = {
  incidentId?: string;
};

export function IncidentDetailContainer({
  incidentId,
}: IncidentDetailContainerProps) {
  const {
    assignModalOpen,
    assignee,
    blockingReason,
    cancelPendingTransition,
    confirmBlockedTransition,
    detail,
    errorMessage,
    hasPersistedDiagnosis,
    handleAssigneeChange,
    handleBack,
    handleCloseAssignModal,
    handleCloseOnsiteModal,
    handleConfirmAssign,
    handleCopyOnsiteMagicLink,
    handleDiagnose,
    handleLaunchOnsiteIntervention,
    handleOpenAssignModal,
    handleTriggerRemoteAction,
    handleStatusTransition,
    isDiagnosing,
    isLaunchingOnsiteIntervention,
    isLaunchingRemoteAction,
    isLoading,
    isTransitionDialogOpen,
    isTransitioning,
    onsiteMagicLink,
    onsiteRecommendedActions,
    pendingTransition,
    setBlockingReason,
    showAssignAction,
    transitioningIncidentId,
  } = useIncidentDetailScreen(incidentId);

  return (
    <IncidentDetailView
      assignModalOpen={assignModalOpen}
      assignee={assignee}
      blockingReason={blockingReason}
      cancelPendingTransition={cancelPendingTransition}
      confirmBlockedTransition={confirmBlockedTransition}
      detail={detail}
      errorMessage={errorMessage}
      hasPersistedDiagnosis={hasPersistedDiagnosis}
      isDiagnosing={isDiagnosing}
      isLaunchingOnsiteIntervention={isLaunchingOnsiteIntervention}
      isLaunchingRemoteAction={isLaunchingRemoteAction}
      isLoading={isLoading}
      isTransitionDialogOpen={isTransitionDialogOpen}
      isTransitioning={isTransitioning}
      onsiteMagicLink={onsiteMagicLink}
      onsiteRecommendedActions={onsiteRecommendedActions}
      pendingTransition={pendingTransition}
      showAssignAction={showAssignAction}
      onAssigneeChangeAction={handleAssigneeChange}
      onBackAction={handleBack}
      onBlockingReasonChangeAction={setBlockingReason}
      onCloseAssignModalAction={handleCloseAssignModal}
      onCloseOnsiteModalAction={handleCloseOnsiteModal}
      onConfirmAssignAction={handleConfirmAssign}
      onCopyOnsiteMagicLinkAction={handleCopyOnsiteMagicLink}
      onDiagnoseAction={handleDiagnose}
      onLaunchOnsiteInterventionAction={handleLaunchOnsiteIntervention}
      onOpenAssignModalAction={handleOpenAssignModal}
      onTriggerRemoteActionAction={handleTriggerRemoteAction}
      onStatusTransitionAction={handleStatusTransition}
      transitioningIncidentId={transitioningIncidentId}
    />
  );
}
